import "virtual:mf-REMOTE_ENTRY_ID:__mfe_internal__glados__remoteEntry-_hash_";
// Use dynamic import to allow webpack to interface with module federation code
import('./bootstrap');
